import React from "react";
import PropTypes from "prop-types";
import { Button } from "reactstrap";

import IconWithTooltip from "shared/react_components/IconWithTooltip";
import Timestamp from "shared/react_components/Timestamp";

import { eventActionButton } from "./styles/EventActions.module.scss";

const EventActions = ({ onAudioJumpPosition, startTime, onAddComment }) => {
  return (
    <>
      {onAddComment &&
        <Button className={eventActionButton}
          outline
          color="link"
          onClick={onAddComment}
          data-test-id="add-comment-button"
        >
          <IconWithTooltip icon="chat" placement="top">
            Add comment
          </IconWithTooltip>
        </Button>
      }
      {onAudioJumpPosition &&
        <Button className={eventActionButton}
          outline
          color="link"
          onClick={() => onAudioJumpPosition(startTime)}
          data-test-id="audio-jump-button"
        >
          <IconWithTooltip icon="play_circle_outline" placement="top">
            Jump to <Timestamp seconds={startTime} trimLeadingZeros />
          </IconWithTooltip>
        </Button>
      }
    </>
  );
};

EventActions.propTypes = {
  onAudioJumpPosition: PropTypes.func,
  startTime: PropTypes.number,
  onAddComment: PropTypes.func
};

export default EventActions;
